import { FC, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { LatLngTuple } from 'leaflet';
import { type SpaceCoordinate } from '@services/useGetSpacesCoordinates';

type MapBoundsUpdaterProps = {
    coordinates: SpaceCoordinate[];
};

export const MapBoundsUpdater: FC<MapBoundsUpdaterProps> = ({ coordinates }) => {
    const map = useMap();

    useEffect(() => {
        if (!coordinates || coordinates.length === 0) {
            return;
        }

        const points = coordinates.reduce<LatLngTuple[]>((acc, item) => {
            const lat = parseFloat(item.latitude || '');
            const lng = parseFloat(item.longitude || '');

            if (!isNaN(lat) && !isNaN(lng)) {
                acc.push([lat, lng]);
            }

            return acc;
        }, []);

        if (points.length === 0) {
            return;
        }

        map.fitBounds(points, { padding: [40, 40] });
    }, [coordinates, map]);

    return null;
};
